const home = {
  infoWindow: {
    area: "จังหวัด",
    licencePlate: "ป้ายทะเบียนรถยนต์",
    title: "ข้อมูลยานพาหนะ",
    model: "โมเดล",
    brand: "ยี่ห้อ",
    dataTime: "Data time",
    gpsSpeed: "GPS speed",
    gpsMileage: "GPS mileage",
    monitor: "Vehicle Monitoring",
    obd: "รหัส OBD",
    gpsTime: "เวลา GPS",
    series: "ซีรี่ย์",
    speed: "Speed"
  }
} 
export default home